import { UseHeader, UseNavigation, UseSignIn, UseUser } from './index';
import Api from '../api';
import Config from '../config/config';
import { query_params } from '../helpers/params';
import UseAlert from './useAlert';

const UseTableGames = () => {
  const navigate = UseNavigation()
  const play=({gameId,loader,callback,lang,platform,params})=>{
    playGame({gameId,loader,callback,lang,platform,params})
  }
  const playGame = ({gameId,loader,callback,lang,platform,params})=>{
    switch(gameId){
      case "joker":
        playJoker({loader,lang,callback});
        break;
      case "poker":
        playPoker({loader,lang,callback});
        break;
      case "japaneseJoker":
        playJapaneseJoker({loader,lang,callback});
        break;
      case "leaderPoker":
        playLeaderPoker({loader,lang,callback});
        break;
      case "liveCasino":
        playLiveCasino({loader,lang,params,platform,callback});
        break;
      default:
        gameUrl({gameId,loader,callback})
        break;
    }
  }
  const gameUrl =({gameId,loader,callback}) =>{
    const Alert = UseAlert()
      Api.TableGames.Play({gameId:gameId,loader:loader})
        .then(response=>{
          console.log(response)
          if(response.status && response?.data?.status === 1){
              callback(response.data.data)
          }
          else if(response?.data?.status === 2){
            Alert.open({
              message: response?.data?.desc || 'თამაშის გახსნისას დაფიქსირდა შეცდომა',
              onCancel: () => navigate.navigate('/')
            })
          }
          else{
            alert("თამაშის გახსნისას დაფიქსირდა შეცდომა");
            navigate.navigate("/")
          }
        })
  }
  const playJoker = ({loader,lang,callback})=>{
    Api.TableGames.GetJokerToken({loader})
      .then((response) => {
        if(response?.data?.token){
          setTimeout(()=>{
              if(window.top.location.href.indexOf("react") > -1){
                  callback(`https://joker1.lider-bet.com/web/${lang}/token/${response?.data?.token}`)
              }else{
                  callback(`https://joker.lider-bet.com/web/${lang}/token/${response?.data?.token}`)
              }

           // window.location.href="https://joker.lider-bet.com/web/".concat(lang?lang:"ka","/token/",response?.data?.token) ;
          },10)
        }else{
          alert("თამაშის გახსნისას დაფიქსირდა შეცდომა");
          navigate.navigate("/")
        }
      });
  }
  const playPoker = ({loader,lang,callback})=>{
    if(window.innerWidth < 720){
      callback(Config.TableGames.LeaderPoker.replace('{platform}',window.innerWidth < 720?'m':'w').concat("&tt=2"))

    }else{
      callback(Config.TableGames.LeaderPoker.replace('{platform}',window.innerWidth < 720?'m':'w').concat("&tt=2"))

    }
    /*
    Api.TableGames.GetPokerToken({loader})
      .then((response) => {
        console.log(response)
        if(response?.data?.token){
            if(window.top.location.href.indexOf("react") > -1){
                callback("https://spinpoker1.lider-bet.com/web/".concat(lang?lang:"ka","/token/",response?.data?.token))
            }else{
                callback("https://spinpoker.lider-bet.com/web/".concat(lang?lang:"ka","/token/",response?.data?.token))
            }

        }else{
          alert("თამაშის გახსნისას დაფიქსირდა შეცდომა");
          navigate.navigate("/")
        }
      });*/
  }
  const playLeaderPoker = ({loader,lang,callback})=>{
      callback(Config.TableGames.LeaderPoker)
  }
  const playJapaneseJoker = ({loader,lang,callback})=>{
    Api.TableGames.GetPokerToken({loader})
      .then((response) => {
        if(response?.data?.token){
            if(window.top.location.href.indexOf("react") > -1){
                callback(`//japanesejoker1.lider-bet.com/web/${lang}/home/verifytoken?token=${response?.data?.token}`)
            }else{
                callback(`//japanesejoker.lider-bet.com/web/${lang}/home/verifytoken?token=${response?.data?.token}`)
            }

        }else{
          alert("თამაშის გახსნისას დაფიქსირდა შეცდომა");
          navigate.navigate("/")
        }
      });
  }
  const playLiveCasino = ({loader,lang,params,platform,callback})=>{
    console.log(platform)
    let url ="";
    switch (params["vendor"]){
      case "evolution":
        url=Config.LiveCasino.Evolution.concat("&".concat(query_params(params)))
        break;
      case "playtechcasino" :
        url=Config.LiveCasino.PlayTech.concat("&".concat(query_params(params)))
        break;
      case "LeaderRoulette" :
        callback(platform==='mob'?"/play/roulette/html/mobile/index.html":"/play/roulette/html/index.html?v9");
        return;
      default:
        navigate.navigate("/");
        break;

    }
    Api.TableGames.GetCasinoToken({
      loader,
      url:url
    })
      .then((response) => {
        if(response?.data?.res===1){
          if(["playtechcasino","evolution"].indexOf(params["vendor"])>-1){
            listener(response.data?.key)
          }
          if(params["vendor"]==="evolution"){
            callback(response?.data?.url);
            return;
          }
         callback(response?.data?.result?.directUrl)
        }else{
          alert('თამაშის გაშვება დროებით შეუძლებელია');
         /* navigate.navigate("/")*/
        }
      });
  }
  const listener = (hash) => {
    Api.Slots.Listener({ hash: hash })
      .then(() => {
        window.timeout = setTimeout(function () {
          listener(hash);
        }, 7000);
      })
      .catch(
        () =>
          (window.timeout = setTimeout(function () {
            listener(hash);
          }, 7000))
      );
  };
  return { play,playJoker,playPoker,playLeaderPoker,playLiveCasino};
};
export default UseTableGames;
